import React, { useEffect } from 'react';
import { Modal, StyleSheet, View } from 'react-native';
import { useRootStackNavigation } from '../../navigation/hooks';
import { NotificationItem } from '../../reminders/store/types';
import { useStateStore } from '../../stores/useStateStore';
import { useAlarmSounds } from '../../utils/systemSounds';
import NotificationModalView from '../NotificationModal/components/NotificationModalView';

interface Props {
  alarms: NotificationItem[];
}

const AlarmScreen = ({ alarms }: Props) => {
  const alarm = alarms?.[0];

  const snoozeAlarm = useStateStore((state) => state.snoozeAlarm);
  const dismissAlarm = useStateStore((state) => state.dismissAlarm);

  // TODO: These are temp functions as we currently only support one alarm in the display instead of multiple.
  const handleSnooze = () => {
    alarms.forEach((a) => (a.id !== alarm.id ? dismissAlarm(a) : null));
    snoozeAlarm(alarm);
  };

  const handleDismiss = () => {
    alarms.map(dismissAlarm);
  };

  const { navigate } = useRootStackNavigation();
  const handleViewDetails = () => {
    navigate('CalendarItemDetails', { id: alarm.id, type: alarm.type });
    // FIXME: This will dismiss all alarms when trying to view something
    handleDismiss();
  };

  const alarm_sound_id = useStateStore(
    (state) =>
      state.current_user?.systemPreferences?.androidAlarmSoundID || undefined
  );

  const { playByID, stop, status: soundsStatus } = useAlarmSounds();

  useEffect(() => {
    if (soundsStatus === 'ready') {
      playByID(alarm_sound_id);
    }

    return () => {
      stop();
    };
  }, [alarm_sound_id, soundsStatus, playByID, stop]);

  return (
    <Modal visible={!!alarm}>
      <View style={styles.screen}>
        <NotificationModalView
          item={alarm}
          onSnooze={handleSnooze}
          onDismiss={handleDismiss}
          onViewDetails={handleViewDetails}
          style={styles.notificationModal}
        />
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  screen: {
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  notificationModal: {
    maxHeight: '70%',
  },
});

export default AlarmScreen;
